import React from "react";
import Card from "react-bootstrap/Card";

const TextCard = props => (
  <div className="textCard">
    <Card className="textCardContent">
      <Card.Body>
        {props.region && <h6 className="alachua-region">{props.region}</h6>}

        <div className="card-body-text">
          {props.name && <h4>{props.name}</h4>}
          <p className="position">{props.position}</p>
          <p className="email">{props.email}</p>
        </div>

      </Card.Body>
    </Card>
  </div>
);

export default TextCard;